import axios from 'axios';
import { User } from '../types/user';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export interface UserProfile {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  avatarUrl?: string;
  shippingAddress?: {
    street?: string;
    city?: string;
    state?: string;
    country?: string;
    postalCode?: string;
  };
  preferences?: {
    theme?: 'light' | 'dark';
    notifications?: boolean;
    language?: string;
  };
  tokens: number;
}

export interface PasswordChangeData {
  currentPassword: string;
  newPassword: string;
}

class UserService {
  private getHeaders() {
    const token = localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  }

  async getProfile(): Promise<UserProfile> {
    try {
      const response = await axios.get(`${API_URL}/users/profile`, {
        headers: this.getHeaders(),
      });
      return response.data.user;
    } catch (error) {
      console.error('Error fetching user profile:', error);
      throw error;
    }
  }

  async updateProfile(profileData: Partial<UserProfile>): Promise<UserProfile> {
    try {
      const response = await axios.put(`${API_URL}/users/profile`, profileData, {
        headers: this.getHeaders(),
      });
      return response.data.user;
    } catch (error) {
      console.error('Error updating user profile:', error);
      throw error;
    }
  }

  async changePassword(passwordData: PasswordChangeData): Promise<void> {
    try {
      await axios.put(`${API_URL}/users/profile/password`, passwordData, {
        headers: this.getHeaders(),
      });
    } catch (error) {
      console.error('Error changing password:', error);
      throw error;
    }
  }

  async uploadAvatar(file: File): Promise<string> {
    try {
      const formData = new FormData();
      formData.append('avatar', file);

      const response = await axios.post(`${API_URL}/users/profile/avatar`, formData, {
        headers: {
          ...this.getHeaders(),
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data.avatarUrl;
    } catch (error) {
      console.error('Error uploading avatar:', error);
      throw error;
    }
  }
}

export const userService = new UserService(); 